import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import GlassSpinner from "../../components/GlassSpinner";
import { compradorMisTickets, compradorPublicConfig } from "../../services/sininApi";

export default function CompraResultado() {
  const { empresaId } = useParams();
  const [params] = useSearchParams();
  const [empresa, setEmpresa] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const ordenId = params.get("ordenId");

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem(`comprador_${empresaId}`) || "null");
    const load = async () => {
      try {
        const cfg = await compradorPublicConfig(empresaId);
        setEmpresa(cfg?.empresa || null);
      } catch {}
      if (saved?.dni && saved?.password) {
        try {
          const res = await compradorMisTickets({ empresaId, dni: saved.dni, password: saved.password });
          setTickets(Array.isArray(res?.items) ? res.items : []);
        } catch {}
      }
      setLoading(false);
    };
    load();
    const timer = setInterval(load, 7000);
    return () => clearInterval(timer);
  }, [empresaId]);

  const color = empresa?.colorTicket || "#dfa66b";
  const colorFuente = empresa?.colorFuente || "#ffffff";

  return (
    <div style={{ minHeight: "100vh", background: empresa?.colorFondo || "#1a1a1a", color: "#fff", padding: 18 }}>
      <div style={{ maxWidth: 640, margin: "0 auto" }}>
        <div style={{ background: "#fff", color: "#222", borderRadius: 24, padding: 22, marginTop: 30, textAlign: "center" }}>
          <h1 style={{ marginTop: 0, textTransform: "uppercase" }}>Compra recibida</h1>
          <p style={{ color: "#666", lineHeight: 1.5 }}>
            Orden {ordenId || ""}. Si el pago fue aprobado, Mercado Pago nos avisa y generamos tus tickets automáticamente.
          </p>
          {loading ? (
            <GlassSpinner size={60} background={empresa?.colorFondo || "#1a1a1a"} />
          ) : tickets.length ? (
            <div style={{ textAlign: "left" }}>
              <h2 style={{ fontSize: 16, textTransform: "uppercase" }}>Mis tickets</h2>
              {tickets.map(t => (
                <div key={t.hashSeguro} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: "1px solid #eee", padding: "12px 0", gap: 10 }}>
                  <div>
                    <b>{t.name}</b>
                    <div style={{ fontSize: 13, color: "#777" }}>{t.tanda} · Ticket {t.numeroTicket}/{t.cantidadTotal}</div>
                  </div>
                  <a href={t.pdf_url} target="_blank" rel="noreferrer"
                    style={{ background: color, color: colorFuente, textDecoration: "none", borderRadius: 25, padding: "9px 13px", fontWeight: 900 }}>
                    VER PDF
                  </a>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ background: "#fff3cd", color: "#856404", borderRadius: 16, padding: 12 }}>
              Todavía no vemos tus tickets. Si acabás de pagar, esperá unos segundos y esta pantalla se actualiza sola.
            </p>
          )}
          <Link to={`/comprar/${empresaId}`} style={{ display: "inline-block", marginTop: 16, color: "#222", fontWeight: 800 }}>
            Volver a eventos
          </Link>
        </div>
      </div>
    </div>
  );
}
